import { render, staticRenderFns } from "./TPDFiles.vue?vue&type=template&id=470a4827"
import script from "./TPDFiles.vue?vue&type=script&lang=js"
export * from "./TPDFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports